import UnimplementedError from '../../exception/unimplementedError';

export default class Device {
  constructor(logger, store, config, dao, eventBus) {
    this.logger = logger;
    this.store = store;
    this.config = config;
    this.dao = dao;
    this.eventBus = eventBus;

    this.loadedImage = null;
  }

  get type() {
    return this.logger.capture(new UnimplementedError());
  }

  get manufacturer() {
    return this.logger.capture(new UnimplementedError());
  }

  get authToken() {
    return this.logger.capture(new UnimplementedError());
  }

  get image() {
    if (!this.loadedImage) {
      throw new UnimplementedError();
    }
    return this.loadedImage; // eslint-disable-line
  }

  get linkUrl() {
    return `${this.config.apiProtocol}://${this.config.apiUrl}${this.config.apiBasePath}`;
  }

  get isLinked() {
    return this.logger.capture(new UnimplementedError());
  }

  link(onWindowClose) {
    const windowHandle = window.open(this.linkUrl);
    const checkWindowHandle = setInterval(() => {
      if (windowHandle.closed) {
        if (onWindowClose) {
          onWindowClose();
        }
        clearInterval(checkWindowHandle);
      }
    }, 1000);
  }

  unlink() {
    this.logger.capture(new UnimplementedError());
  }
}
